import { useCallback } from 'react';

import InlineSvg from 'approot/shared/inline-svg/inline-svg';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import { useInteractiveAudioContext } from './interactive-audio.context';
import IconAudioOff from 'approot/shared/icons/icon-audio-off';

type Props = {
  itemId: string;
  description: string | null;
  withTooltip?: boolean;
};

const InteractiveResponseAudioButton = ({
  itemId,
  description,
  withTooltip = false,
}: Props) => {
  const { playAudio, pauseAudio, isPlaying, currentAudioId } =
    useInteractiveAudioContext();

  const isAudioPlaying = isPlaying && currentAudioId === itemId;

  const togglePlayback = useCallback(() => {
    if (isAudioPlaying) {
      pauseAudio();
    } else {
      playAudio(itemId);
    }
  }, [isAudioPlaying, playAudio, pauseAudio, itemId]);

  const button = (
    <SecondaryButtonIcon
      type="button"
      as="div"
      role="button"
      $borderRadius={40}
      aria-label={
        isAudioPlaying
          ? `Pause audio for ${description}`
          : `Play audio for ${description}`
      }
      onClick={(e: any) => {
        e.stopPropagation();
        togglePlayback();
      }}
    >
      {isAudioPlaying ? (
        <IconAudioOff width={20} height={20} />
      ) : (
        <InlineSvg id="audio" width={20} height={20} />
      )}
    </SecondaryButtonIcon>
  );

  return withTooltip ? (
    <TooltipWrapper hoverText="Play audio">{button}</TooltipWrapper>
  ) : (
    button
  );
};

export default InteractiveResponseAudioButton;
